<template>
  <div>
    <table v-if="hasDiffs" class="mergeTable" width="100%">
        <thead>
        <tr>
          <th align="center" width="33%" style="padding-right: 5px;"><a @click="res = JSON.parse(JSON.stringify(o))">Старое</a></th>
          <th align="center" width="34%" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;"> ← diff →</th>
          <th align="center" width="33%" style="padding-left: 5px;"><a @click="res = JSON.parse(JSON.stringify(n))">Новое</a></th>
        </tr>
        </thead>
        <tbody v-for="(eee,index) in maxCount">
        <tr>
          <td v-if="oToText[index]"  :class="{'selected': resToText[index] === oToText[index]}" valign="top" style="padding-right: 5px;">
            <a @click="setRes(index, 'old')">{{ oToText[index] }}</a>
          </td>
          <td v-else  valign="top" style="padding-right: 5px;"> <a @click="res.splice(index,1)">X</a></td>
          <td valign="top" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;">
            <span class="diff" v-html="getDiff(index)"/>
          </td>
          <td v-if="nToText[index]"  :class="{'selected': resToText[index] === nToText[index] && nToText[index] !== oToText[index]}" valign="top" style="padding-left: 5px;">
            <a @click="setRes(index, 'new')">{{ nToText[index]}}</a>
          </td>
          <td v-else  valign="top" style="padding-right: 5px;"> <a @click="res.splice(index,1)">X</a></td>
        </tr>
        </tbody>
    </table>
    <table class="mergeTable" width="100%">
      <thead>
      <tr>
        <th align="center" colspan="100%">Актуальное</th>
      </tr>
      </thead>
      <tbody v-for="(row, index) in res" class="hover">
      <tr style="height: 31px">
        <td colspan="89%" class="selected" style="vertical-align: top;">
          <EducationSelect :item="row.univercity"
                           @selected="(newVal) => onEducationSelect(newVal, index)"
                           @paste="(text) => onEducationPaste(text, index)"
                           ref="univercity"/>
        </td>
        <td colspan="11%"  class="selected" style="vertical-align: top; padding-left: 5px;">
            <ValidationProvider
                v-slot="{ errors }"
                :rules="{numeric:true, min_value:1900, max_value:currentYear}"
            >
                <input
                    v-model="row.year"
                    placeholder="Год"
                    type="number" min="1900"
                    v-units.literal="`г`"
                    style="text-align: left !important;"

                    :class="{'hasError' : errors[0]}"
                    v-tooltip="{
                       content: errors[0],
                       template: $errTemplate,
                    }"
                />
            </ValidationProvider>
        </td>
      </tr>
      <tr style="margin-bottom: 5px;height: 31px">
        <td colspan="45%" class="selected">
          <input v-model="row.speciality"
                 placeholder="Специальность"
                 ref="speciality"
                 class="educationSpeciality"
                 @paste="onPasteSpeciality(index, $event)"
                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
          >
        </td>
        <td colspan="44%" class="selected" style="padding-left: 5px;">
          <v-select
              v-model="row.grade"
              :options='[
                                { value: "", text: "\u00a0" },
                                { value: "базовое образование", text: "базовое образование" },
                                { value: "интернатура", text: "интернатура" },
                                { value: "ординатура", text: "ординатура" },
                                { value: "аспирантура", text: "аспирантура" },
                                { value: "докторантура", text: "докторантура" },
                            ]'
          />
        </td>
        <td colspan="11%" align="right" class="selected">
          <button class="small blueHover"
                  @click.prevent="moveEducationToCertificates(index)"
                  tabindex="-1"
                  v-tooltip="'Перенести в курсы и сертификаты'">
            →Курс
          </button>
          <button @click="res.splice(index, 1)" class="small redHover square"  tabindex="-1">
            <i class="far fa-trash-can"></i></button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr style="height: 38px;">
        <td colspan="100%" style="text-align: center;">
          <button @click="addEducation" class="small addEducation" tabindex="-1">Добавить образование</button>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>

</template>
<script>
import Base from "../Base.vue";
import DiffMatchPatch from 'diff-match-patch';
import _ from "lodash";
import EducationSelect from "../../../dialogs/common/doctors/EducationSelect";

export default {
    components: {EducationSelect},
    mixins:[Base],
    props: {
      o: {
        type: [Array],
        default: ''
      },
      n: {
        type: [Array],
        default: ''
      },
      f: {
        type: [Array],
        default: ''
      },
      full: {
        type: Object,
        default: () => {},
      }
    },
    data: function () {
        return {
          resToText: []
        }
    },
  created() {
      this.resToText = this.res.map( (item) => item.univercity+ ' ' +item.year + ' ' + item.speciality + ' ' + item.grade);

      this.$root.$on('education-changed', i => {
          this.$refs.university[i].$refs.multiselect.search = this.f[i].univercity;
      })
  },
  methods: {
      onEducationSelect(value, index) {
          this.res[index].univercity = value;
      },
      onEducationPaste(text, index) {
        text = this.cutQuotes(text);
        text = text.trim();

        if (text) {
          let data = this.parseEducation(text);

          if (!this.res[index].year) {
            this.res[index].year = data.year;
          }
          if (!this.res[index].speciality) {
            this.res[index].speciality = data.speciality;
          }
          if (!this.res[index].grade) {
            this.res[index].grade = data.grade;
          }
        }
      },
      setRes(index, type) {
        if (type === 'old') {
          this.res.splice(index, 1, JSON.parse(JSON.stringify(this.o[index])));
        }
        if (type === 'new') {
          this.res.splice(index, 1, JSON.parse(JSON.stringify(this.n[index])));
        }
      },
      addEducation (focus) {
        this.res.push({year: '', univercity: '', speciality: '', grade: ''});
      },
      getDiff(index) {
        let dmp = new DiffMatchPatch();
        let d = dmp.diff_main(this.oToText[index] ?? '',this.nToText[index] ?? '');
        dmp.diff_cleanupEfficiency(d);
        return dmp.diff_prettyHtml(d);
      },
      onPasteSpeciality(index, e) {
          let input = this.$refs.speciality[index];
          let text = e.clipboardData.getData('text/plain');

          let newText = input.selectionStart.substring(0, input.selectionEnd) + text + origin.substring(input.selectionEnd);
          this.res[index].speciality = _.upperFirst(newText.split('\n').join(' ').trim());

          e.preventDefault();
      },
      moveEducationToCertificates: function (index) {
          // Название вуза и Специальность через пробел
          let row = this.res[index];

          if (
              !!(this.full.certificates[this.full.certificates.length - 1]) &&
              _.isEmpty(this.full.certificates[this.full.certificates.length - 1].univercity) &&
              _.isEmpty(this.full.certificates[this.full.certificates.length - 1].year[0])
          ) {
              this.full.certificates = this.full.certificates.slice(0, -1);
          }

          this.full.certificates.push({
              univercity: [row.univercity, row.speciality].join(' ').trim(),
              year: [row.year]
          });
          this.res.splice(index, 1);

          let certIndex = this.full.certificates.length - 1;
          let lastYearIndex = this.full.certificates[certIndex].year.length - 1;

          if ((this.full.certificates[certIndex].year.length === 0) || (this.full.certificates[certIndex].year[lastYearIndex] !== '')) {
              this.full.certificates[certIndex].year.push("");
          }

          this.full.certificates.push({univercity: '', year: ['']});
      },
      parseEducation(line) {
          let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
              if (acc === '') {
                  let y = parseInt(val);
                  if ((1970 <= y && y <= 2030)) {
                      return y;
                  } else if ((70 <= y && y <= 99)) {
                      return 1900 + y;
                  }
              }
              return acc;
          }, '');

          let speciality = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
              if (acc === '') {
                  val = val.toLowerCase();

                  if (val.startsWith('лечебн')) {
                      return 'Лечебное дело';

                  } else if (val.startsWith('педиатр')) {
                      return 'Педиатрия';

                  } else if (val.startsWith('стоматолог')) {
                      return 'Стоматология';

                  } else if (val.startsWith('акушер')) {
                      return 'Акушерство и гинекология';

                  } else if (val.startsWith('гинеколог')) {
                      return 'Гинекология';

                  } else if (val.startsWith('терап')) {
                      return 'Терапия';

                  } else if (val.startsWith('хирург')) {
                      return 'Хирургия';

                  } else if (val.startsWith('невролог')) {
                      return 'Неврология';

                  } else if (val.startsWith('дерматовенерол')) {
                      return 'Дерматовенерология';

                  } else if (val.startsWith('офтальмолог')) {
                      return 'Офтальмология';

                  } else if (val.startsWith('уролог')) {
                      return 'Урология';

                  } else if (val.startsWith('психолог')) {
                      return 'Психология';

                  } else if (val.startsWith('фельдшер')) {
                      return 'Фельдшер';

                  } else if (val.startsWith('зубной')) {
                      return 'Стоматология';

                  } else if (val.startsWith('общей')) {
                      return 'Врач общей практики';

                  } else if (val.startsWith('эндокринолог')) {
                      return 'Эндокринология';

                  } else if (val.startsWith('кардиолог')) {
                      return 'Кардиология';

                  } else if (val.startsWith('психиатр')) {
                      return 'Психиатрия';

                  } else if (val.startsWith('оториноларинголог')) {
                      return 'Оториноларингология';

                  } else if (val.startsWith('рентгенолог')) {
                      return 'Рентгенология';

                  } else if (val.startsWith('терапевт')) {
                      return 'Терапевт';

                  } else if (val.startsWith('логопед')) {
                      return 'Логопедия';

                  } else if (val.startsWith('брат')) {
                      return 'Медицинский брат';

                  } else if (val.startsWith('сестр')) {
                      return 'Сестринское дело';

                  } else if (val.startsWith('массаж')) {
                      return 'Медицинский массаж';

                  } else if (val.startsWith('онколог')) {
                      return 'Онкология';

                  } else if (val.startsWith('дефектолог')) {
                      return 'Дефектология';

                  } else if (val.startsWith('отоларинголог')) {
                      return 'Отоларингология';

                  }
              }
              return acc;
          }, '');

          let grade = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
              if (acc === '') {
                  val = val.toLowerCase();

                  if (val.startsWith('интерн')) {
                      return 'интернатура';

                  } else if (val.startsWith('ординат')) {
                      return 'ординатура';

                  } else if (val.startsWith('аспирант')) {
                      return 'аспирантура';

                  } else if (val.startsWith('доктор')) {
                      return 'докторантура';
                  }
              }
              return acc;
          }, '');

          let university = this.cutLastComma(_.upperFirst(line).trim());

          return {
              univercity: university,
              year: year,
              speciality: speciality,
              grade: grade
          };
      },
      cutQuotes(text) {
          if (text[0] === '«' && text[text.length - 1] === '»') {
              text = text.slice(1, text.length - 1);
          }

          return text;
      },
      cutLastComma(text) {
          if (text[text.length - 1] === ',') {
              text = text.slice(0, text.length - 1);
          }

          return text;
      },
  },
  watch: {
    res: {
      deep: true,
      handler: function(value) {
        this.resToText = value.map( (item) => item.univercity+ ' ' +item.year + ' ' + item.speciality + ' ' + item.grade);
      }
    },
  },
  computed: {
      hasDiffs () {
        return !_.isEqual(this.o, this.n)
      },
      currentYear () {
          return new Date().getFullYear() ?? 2400;
      },
      oToText () {
        return this.o.map( (item) => item.univercity+ ' ' +item.year + ' ' + item.speciality + ' ' + item.grade)
      },
      nToText () {
        return this.n.map( (item) => item.univercity+ ' ' +item.year + ' ' + item.speciality + ' ' + item.grade)
      },
      maxCount () {
        return Math.max(this.oToText.length,this.nToText.length)
      },
    }
}
</script>
